import { SpeakerAgenda } from '../agenda-event/speaker-agenda';
import { ProgramEvent, ProgramEventPerson } from '@cue/api';
import { Button } from '@cue/atoms';
import { useQueryParams } from '@cue/hooks';
import { Modal, useModal } from '@cue/organisms';
import { useEffect, useState } from 'react';
import slugify from 'slugify';
import { AgendaDisplayOptions } from '../agenda';

interface AgendaSpeakerModalProps {
  events?: ProgramEvent[];
  agendaDisplayOptions?: AgendaDisplayOptions;
}

export const AgendaSpeakerModal = (props: AgendaSpeakerModalProps) => {
  const { events, agendaDisplayOptions } = props;

  const [params, setParams] = useQueryParams();
  const [modalRef] = useModal();
  const [currentSpeaker, setCurrentSpeaker] = useState<ProgramEventPerson | null>(null);

  useEffect(() => {
    if (currentSpeaker) {
      modalRef.current?.open();
    } else {
      modalRef.current?.close();
    }
  }, [currentSpeaker, modalRef]);

  useEffect(() => {
    const findSpeaker = (slug: string) => {
      const match =
        events
          ?.find((event) => {
            return event.persons?.find((person) => {
              return slugify(person.name, { lower: true }) === slug;
            });
          })
          ?.persons?.find((person) => {
            return slugify(person.name, { lower: true }) === slug;
          }) || null;
      setCurrentSpeaker(match);
    };
    if (params.speaker) {
      findSpeaker(slugify(params.speaker));
    } else {
      setCurrentSpeaker(null);
    }
  }, [params, events]);

  return (
    <>
      {}
      <Modal
        ref={modalRef}
        placement={{ vertical: 'top', horizontal: 'center' }}
        overrideCSS={{
          '.cue-modal-content': {
            width: '95vw',
            maxWidth: 1280,
            background: 'rgb(0, 24, 59)',
            padding: 30,
          },
          // '.cue-modal-close-button-wrapper': {
          //   right: '0px',
          //   top: '0px',
          //   button: {
          //     borderRadius: '999px',
          //     width: '20px',
          //     height: '30px',
          //     '&:hover': {
          //       path: {
          //         fill: '#000028',
          //       },
          //     },
          //   },
          // },
          // '.cue-modal-container': {
          //   padding: 30,
          //   background: '#002949',
          // },
          // '.cue-modal-close-button-wrapper': {
          //   position: 'absolute',
          //   top: 0,
          //   right: 0,
          // },
        }}
        customCloseRenderer={() => (
          <Button
            icon="close"
            styling="close"
            onClick={() => {
              setTimeout(() => {
                setParams({ ...params, speaker: null });
              }, 1000);
              if (modalRef?.current?.animatedClose)
                modalRef.current.animatedClose({ className: 'modal-fade-out', duration: 500 });
            }}
          />
        )}>
        {currentSpeaker && (
          <SpeakerAgenda
            agendaDisplayOptions={agendaDisplayOptions}
            speaker={currentSpeaker}
            hideLocation={true}
            onSpeakerClick={(speaker) => {
              setCurrentSpeaker(speaker);
            }}
          />
        )}
      </Modal>
    </>
  );
};
